/*
 * Copyright 2022, Corning Optical Communications
 * All Rights Reserved.
 */

import { apiSlice } from "../apiSlice";
import { API } from "../../../globals/globals";
import { FetchBaseQueryMeta } from "@reduxjs/toolkit/query";

export const authApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    login: builder.mutation({
      query: (credentials) => ({
        url: API.ENDPOINTS.LOGIN.path,
        method: "POST",
        body: { ...credentials },
      }),
    }),
    refresh: builder.mutation({
      query: (token) => ({
        url: API.ENDPOINTS.REFRESH.path,
        method: "POST",
        body: { token },
      }),
    }),
    getStandby: builder.query<boolean, void>({
      query: () => ({
        url: API.ENDPOINTS.ISSTANDBY.path,
        method: "GET",
      }),
      transformResponse: (response: boolean) => {
        return response; 
      },
    }),
    // getSsoEnabled: builder.query<any, void>({
    //   query: () => ({
    //     url: `${API.ENDPOINTS.SSOENABLED.path}`,
    //   }),
    // }),
    getSsoEnabled: builder.mutation<any, void>({
      query: () => ({
        url: `${API.ENDPOINTS.SSOENABLED.path}`,
      }),
      transformResponse: (data: any, meta: FetchBaseQueryMeta) => {
        return { status: meta?.response?.status, ...data };
      },
    }),
    logoutAudit: builder.mutation({
      query: (credentials) => ({
        url: API.ENDPOINTS.LOGOUT.path,
        method: "POST",
        body: { ...credentials },
      }),
    }),
  }),
});

export const { useLoginMutation, useRefreshMutation, useGetSsoEnabledMutation, useGetStandbyQuery,useLogoutAuditMutation } = authApiSlice;
